import { RootStore } from './RootStore';

/**
 * Инстанс `RootStore`
 */
export const rootStore = new RootStore();

/**
 * Глобальный стор нотификаций
 */
export const notificationsStore = rootStore.notificationsStore;

/**
 * Глобальный стор query-параметров
 */
export const queryParamsStore = rootStore.queryParamsStore;

/**
 * Глобальный стор сессии пользователя
 */
export const userStore = rootStore.userStore;

/**
 * Глобальный стор справочника проектов
 */
export const projectsHandbookStore = rootStore.projectsHandbookStore;

/**
 * Глобальный стор справочника типов помещений
 */
export const placeTypeHandbookStore = rootStore.placeTypeHandbookStore;

/**
 *  Глобальный стор подписок на web push
 */
export const pushSubscribeStore = rootStore.pushSubscribeStore;

/**
 *  Глобальный стор уведомлений пользователя
 */
export const userNotificationsStore = rootStore.userNotificationsStore;

/**
 *  Глобальный стор детальной информации о заявке
 */
export const leadDrawer = rootStore.leadDrawer;

/**
 * Глобыльный стор детальной информации о встрече
 */
export const meetingDrawer = rootStore.meetingDrawer;
